import React from 'react';

export default function FoundValue({ value }) {
  return <p className="font-semibold text-lg text-blue-900">{value}</p>;
}
